import { useMutation } from '@tanstack/react-query';
import { fetchSelecionarNfsePdf } from '../api/SelecionarNfsePdfApi';
import type { SelecionarNfsePdfResponse } from '../types';

export function useSelecionarNfsePdf() {
  return useMutation<SelecionarNfsePdfResponse, Error, string>({
    mutationFn: fetchSelecionarNfsePdf,
  });
}
